import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";

export const AddStepDialog = ({ open, onOpenChange, newStep, setNewStep, onSave, saving }) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Step</DialogTitle>
          <DialogDescription>Add a new onboarding step</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <label className="text-sm font-medium">Title *</label>
            <Input
              value={newStep.title}
              onChange={(e) => setNewStep({...newStep, title: e.target.value})}
              placeholder="e.g., Initial Setup Call"
              className="mt-1"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Description</label>
            <Textarea
              value={newStep.description}
              onChange={(e) => setNewStep({...newStep, description: e.target.value})}
              placeholder="Step details..."
              className="mt-1"
              rows={2}
            />
          </div>
          <div>
            <label className="text-sm font-medium">Due Date (optional)</label>
            <Input
              type="date"
              value={newStep.due_date}
              onChange={(e) => setNewStep({...newStep, due_date: e.target.value})}
              className="mt-1"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSave} disabled={saving}>
            {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Add Step
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
);

export const EditStepDialog = ({ open, onOpenChange, editingStep, setEditingStep, onSave, saving }) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Step</DialogTitle>
        </DialogHeader>
        {editingStep && (
          <div className="space-y-4 py-4">
            <div>
              <label className="text-sm font-medium">Title *</label>
              <Input
                value={editingStep.title}
                onChange={(e) => setEditingStep({...editingStep, title: e.target.value})}
                className="mt-1"
              />
            </div>
            <div>
              <label className="text-sm font-medium">Description</label>
              <Textarea
                value={editingStep.description || ""}
                onChange={(e) => setEditingStep({...editingStep, description: e.target.value})}
                className="mt-1"
                rows={2}
              />
            </div>
            <div>
              <label className="text-sm font-medium">Due Date</label>
              <Input
                type="date"
                value={editingStep.due_date || ""}
                onChange={(e) => setEditingStep({...editingStep, due_date: e.target.value})}
                className="mt-1"
              />
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSave} disabled={saving}>
            {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
);

export const DeleteCustomerDialog = ({ open, onOpenChange, customer, onConfirm }) => (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Customer?</AlertDialogTitle>
          <AlertDialogDescription>
            This will permanently delete {customer?.name} and all their onboarding data.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-red-600 hover:bg-red-700">
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
);
